import testCommitTypes from "./commit-types";


const INITIAL_TEST_TEMPLATES_STATE = {
  list: [],
  forGrade: [],
  map: {}
};

function testReducers(state = INITIAL_TEST_TEMPLATES_STATE, action) {
  if (!action || !action.type) {
    return state;
  }

  switch (action.type) {
    case testCommitTypes.SET_TESTS:
      return {
        ...state,
        list: action.list,
        map: action.list.reduce((acc, tt) => ({...acc, [tt.id]: tt}), state.map)
      };
    case testCommitTypes.SET_TESTS_FOR_GRADE:
      return {
        ...state,
        forGrade: action.list,
        map: action.list.reduce((acc, tt) => ({...acc, [tt.id]: tt}), state.map)
      };
    case testCommitTypes.PUSH_TESTS:
      return {
        ...state,
        list: [...state.list, action.test],
        map: {
          ...state.list,
          [action.test.id]: action.test
        }
      };
    case testCommitTypes.DELETE_TEST:
      return {
        ...state,
        list: state.list.filter(test => test.id !== action.testId),
      };
    case testCommitTypes.UPDATE_TEST:
      return {
        ...state,
        list: state.list.map(tt => tt.id === action.test.id ? action.test : tt),
        map: {
          ...state.list,
          [action.test.id]: action.test
        }
      };
    case testCommitTypes.START_TEST:
      return {
        ...state,
        list: state.list.map(tt => tt.id === action.test.id ? action.test : tt),
        map: {
          ...state.list,
          [action.test.id]: action.test
        }
      };
    case testCommitTypes.FINISH_TEST:
      return {
        ...state,
        list: state.list.map(tt => tt.id === action.test.id ? action.test : tt),
        map: {
          ...state.list,
          [action.test.id]: action.test
        }
      };
    case testCommitTypes.GRADE_TEST:
      return {
        ...state,
        list: state.list.map(tt => tt.id === action.test.id ? action.test : tt),
        map: {
          ...state.list,
          [action.test.id]: action.test
        }
      };
    case testCommitTypes.RETRY_TEST:
      return {
        ...state,
        list: [...state.list, action.test],
        map: {
          ...state.list,
          [action.test.id]: action.test,
        }
      };
    default:
      return state;
  }
}

export default testReducers
